import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const KEY = "alphalane_lang";

const detect = () => {
  if (typeof window === "undefined") return "de";
  const saved = localStorage.getItem(KEY);
  if (saved === "de" || saved === "en") return saved;
  const navLang = (navigator.language || "de").toLowerCase();
  return navLang.startsWith("de") ? "de" : "en";
};

const LanguageContext = createContext({ lang: "de", setLang: () => {}, t: translations.de });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("de");

  useEffect(() => {
    setLangState(detect());
  }, []);

  const setLang = (next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      localStorage.setItem(KEY, next);
      document.documentElement.lang = next;
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
